<template>
  <v-row>
    <v-col cols="12">
      <v-select
        v-model="model"
        :disabled="disabled"
        :item-text="itemText"
        :item-value="itemValue"
        :items="filteredLanguages"
        :label="$t('customizations.language')"
        class="d-flex justify-center align-center"
        dense
        hide-details="auto"
        outlined
      >
        <template v-if="allowAddLanguage" v-slot:append-outer>
          <v-btn color="primary" outlined @click="showLanguageDialog">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
          <v-btn class="ml-2" v-if="filteredLanguages.length" color="primary" outlined @click="showDeleteDialog">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-select>
    </v-col>
    <v-row v-if="showDialog && allowAddLanguage">
      <v-dialog v-model="showDialog" max-width="400px">
        <v-card elevation="0">
          <v-card-text>
            <v-card-title mt-2 style="justify-content: center;">{{ $t('customizations.addLanguage') }}</v-card-title>
            <v-autocomplete
              v-model="selectedLanguage"
              :items="allLanguages"
              :label="$t('customizations.language')"
              dense
              hide-details="auto"
              item-text="name"
              item-value="code"
              outlined
            />
          </v-card-text>
          <v-card-actions class="pa-0 mt-2">
            <v-btn
              color="primary"
              style="width: 50%"
              tile
              @click="addLanguage"
            >
              {{ $t('pickingForm.validate') }}
            </v-btn>
            <v-btn
              class="ml-0"
              color="secondary"
              style="width: 50%"
              tile
              @click="close">
              {{ $t('pickingForm.cancel') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <confirmation-dialog
      v-if="deleteDialog"
      v-model="deleteDialog"
      :text="$t('customizations.deleteDialogText', {language: this.languageToDelete.name})"
      :title="$t('customizations.deletionDialogTitle')"
      @no="deleteDialog = false"
      @yes="deleteLanguage()"
    ></confirmation-dialog>
  </v-row>
</template>

<script>
  import languages from '@/data/language.json'
  import ConfirmationDialog from '@/components/ConfirmationDialog'

  export default {
    name: 'LanguageSelect',
    components: {
      ConfirmationDialog
    },
    data () {
      return {
        AllLanguages: [],
        filteredLanguages: [],
        showDialog: false,
        selectedLanguage: null,
        deleteDialog: false,
        languageToDelete: null
      }
    },
    props: {
      itemText: {
        type: String,
        required: false,
        default: 'name'
      },
      itemValue: {
        type: String,
        required: false,
        default: 'code'
      },
      value: {
        type: String,
        required: true,
        default: ''
      },
      languageToFilter: {
        type: Array,
        required: false,
        default () {
          return []
        }
      },
      disabled: {
        type: Boolean,
        required: false,
        default: false
      },
      allowAddLanguage: {
        type: Boolean,
        required: false,
        default: false
      },
      filter: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    mounted () {
      this.allLanguages = languages.map((country) => {
        let languageTrad = new Intl.DisplayNames([this.$i18n.locale], { type: 'language' })
        country.name = languageTrad.of(country.code).toUpperCase()
        return country
      })
      this.filteredLanguages = this.allLanguages
      if (this.filter) {
        this.filteredLanguages = this.allLanguages.filter((item) => this.languageToFilter.includes(item.code))
      }
    },
    computed: {
      model: {
        get () {
          return this.value
        },
        set (value) {
          this.$emit('input', value)
        }
      },
      locale () {
        return this.$i18n.locale
      }
    },
    methods: {
      showLanguageDialog () {
        this.showDialog = true
      },
      addLanguage () {
        let selectedLanguage = this.allLanguages.find((item) => item.code === this.selectedLanguage)
        this.filteredLanguages.push(selectedLanguage)
        this.model = this.selectedLanguage
        this.showDialog = false
        this.$emit('languageAdded', this.selectedLanguage)
      },
      close () {
        this.deleteDialog = false
      },
      showDeleteDialog () {
        this.languageToDelete = this.filteredLanguages.find((item) => item.code === this.model)
        this.deleteDialog = true
      },
      deleteLanguage () {
        this.deleteDialog = false
        this.$emit('deleteLanguage', this.model)
      }
    }
  }
</script>
